export default __webpack_public_path__ + "static/media/img1.6cf0af9c.png";